import { PREPARING_EXPORT } from "Flocknote/GlobalComponents/Modal/contentKeys";
import { useNetworkMetadata } from "Flocknote/apiHooks";
import flocknoteStateHooks from "Flocknote/stateHooks";

import { useBoards } from "Boards/BoardContext";
import { useSignups } from "Signups/state.js";

import FnrIcon from "UI/FnrIcon";
import { FnrToggleChild } from "UI/FnrToggle2";

import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3";

import { Icon, RespondentsDataButton, SubText, Text, Title } from "./styles";

export default function ExportButton({ disabled = false, setShowPopover }) {
  const [
    {
      currentSignupList: { ID: signupListID },
    },
  ] = useSignups();
  const [{ boardID }] = useBoards();
  const [, { openModal }] = flocknoteStateHooks.useModal();
  const [{ hasQueuedExports }] = useNetworkMetadata();

  const exportSignup = () => {
    /* 
    For exporting a signup, we want to use the boards export URL if 
    the user is initiating the export from a board (this would be for nets with FNP).
    Otherwise we'll still use the original Singups export URL. 
    */
    const exportAsBoard = boardID && Number(boardID) !== 0;
    const origin = window.location.origin;

    // const url = exportAsBoard
    //   ? `${origin}/board/${boardID}/export?signupListID=${signupListID}`
    //   : `${origin}/signuplist/${signupListID}/export`;

    if (exportAsBoard && hasQueuedExports) {
      const fetch = new FnrFetch3(
        `${origin}/board/${boardID}/export?signupListID=${signupListID}`
      );
      fetch
        .post()
        .then((res) => {
          if (res.success) {
            openModal(PREPARING_EXPORT, { exportID: res.exportID });
            setShowPopover(false);
            window.checkBackgroundJobs();
          } else {
            console.error("Error exporting signup", res);
          }
        })
        .catch((err) => {
          console.error("Error exporting signup", err);
        });
    } else if (exportAsBoard) {
      window.open(
        `${origin}/board/${boardID}/export?signupListID=${signupListID}`
      );
      setShowPopover(false);
    } else {
      window.open(`${origin}/signuplist/${signupListID}/export`);
      setShowPopover(false);
    }
  };

  return (
    <FnrToggleChild disabled={disabled}>
      <RespondentsDataButton onClick={disabled ? null : exportSignup}>
        <Icon>
          <FnrIcon fad fa-file-spreadsheet />
        </Icon>
        <Text>
          <Title>Export respondents list</Title>
          <SubText>
            {`Click here to export this Signup's respondents into an Excel file.`}
          </SubText>
        </Text>
      </RespondentsDataButton>
    </FnrToggleChild>
  );
}